<template>
  <div class="my-vue-upload-component">
    <b-modal v-model="removeImageAcc" :cancel-title="$t('general.no')" :ok-title="$t('general.yes')"
             centered
             size="sm" @cancel="removeImageAcc = false" @ok="removeImage">
      <p>{{ $t('toastification.areYouSureOfDeletion', {item: itemToDelete ? itemToDelete.name : ''}) }}</p>
    </b-modal>
    <vue-upload-component
        ref="editUpload"
        :multiple="false"
        :accept="accept"
        :input-id="editFileId"
        @input-filter="editImage"
    >
    </vue-upload-component>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>#</th>
          <th>{{$t('uploader.thumb')}}</th>
          <th>{{$t('uploader.name')}}</th>
          <th v-if="description">{{$t('uploader.description')}}</th>
          <th>{{$t('uploader.action')}}</th>
          <!--            <th>Width</th>-->
          <!--            <th>Height</th>-->
          <!--            <th>Size</th>-->
          <!--            <th>Speed</th>-->
          <!--            <th>Status</th>-->
          <!--            <th>Action</th>-->
        </tr>
        </thead>
        <tbody>
        <tr v-if="!files.length">
          <td colspan="9">
            <span >{{ $t('uploader.noFile') }}</span>
<!--            <div class="text-center p-5">-->
<!--              <h4>Drop files anywhere to upload<br/>or</h4>-->
<!--              <label :for="name" class="btn btn-lg btn-primary">Select Files</label>-->
<!--            </div>-->
          </td>
        </tr>
        <tr v-for="(file, index) in files" :key="index">
          <td>{{ index + 1 }}</td>
          <td>
<!--            <img class="img-fluid rounded" :src="images[index].url" @click="imageView(index)">-->
            <img class="td-image-thumb" v-if="file.url" :src="file.url" @click="imageView(index)"/>
            <span v-else>{{ $t('upload.noImage') }}</span>
<!--            <vue-upload-component-->
<!--                :ref="`${reference}-${index}`"-->
<!--                @input-file="editImage(file, index)"-->
<!--                :multiple="false"-->
<!--            >-->
<!--            <div class="text-center p-5">-->
              <label :for="editFileId" @click="editFileIndex = index"> <b-icon icon="pencil" class="mx-2" aria-hidden="true" ></b-icon></label>
<!--            </div>-->
<!--              <b-icon :for="name" icon="pencil" class="mx-2" aria-hidden="true" ></b-icon>-->
<!--            </vue-upload-component>-->

          </td>
          <td>
            <div class="filename">
              {{ file.name }}
            </div>
            <!--              <div class="progress" v-if="file.active || file.progress !== '0.00'">-->
            <!--                <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>-->
            <!--              </div>-->
          </td>
          <td v-if="description">
            <b-col>
              <b-form-group

                  label-for="upload-component-description"
              >
                <b-form-input
                    @input=""
                    input-id="file2"
                    id="upload-component-description"
                    v-model="file.description"
                />
              </b-form-group>
            </b-col>
          </td>
          <td>
            <label @click="acceptToRemove(file) "> <b-icon icon="trash" scale="1.5" class="mx-2" aria-hidden="true" ></b-icon></label>
          </td>
          <!--            <td>{{file.width || 0}}</td>-->
          <!--            <td>{{file.height || 0}}</td>-->
          <!--            <td>{{$formatSize(file.size)}}</td>-->
          <!--            <td>{{$formatSize(file.speed)}}</td>-->

          <!--            <td v-if="file.error">{{file.error}}</td>-->
          <!--            <td v-else-if="file.success">success</td>-->
          <!--            <td v-else-if="file.active">active</td>-->
          <!--            <td v-else></td>-->
          <!--            <td>-->
          <!--              <div class="btn-group">-->
          <!--                <button class="btn btn-secondary btn-sm dropdown-toggle" type="button">-->
          <!--                  Action-->
          <!--                </button>-->
          <!--                <div class="dropdown-menu">-->
          <!--                  <a :class="{'dropdown-item': true, disabled: file.active || file.success || file.error === 'compressing' || file.error === 'image parsing'}" href="#" @click.prevent="file.active || file.success || file.error === 'compressing' ? false :  onEditFileShow(file)">Edit</a>-->
          <!--                  <a :class="{'dropdown-item': true, disabled: !file.active}" href="#" @click.prevent="file.active ? $refs.upload.update(file, {error: 'cancel'}) : false">Cancel</a>-->

          <!--                  <a class="dropdown-item" href="#" v-if="file.active" @click.prevent="$refs.upload.update(file, {active: false})">Abort</a>-->
          <!--                  <a class="dropdown-item" href="#" v-else-if="file.error && file.error !== 'compressing' && file.error !== 'image parsing' && $refs.upload.features.html5" @click.prevent="$refs.upload.update(file, {active: true, error: '', progress: '0.00'})">Retry upload</a>-->
          <!--                  <a :class="{'dropdown-item': true, disabled: file.success || file.error === 'compressing' || file.error === 'image parsing'}" href="#" v-else @click.prevent="file.success || file.error === 'compressing' || file.error === 'image parsing' ? false : $refs.upload.update(file, {active: true})">Upload</a>-->

          <!--                  <div class="dropdown-divider"></div>-->
          <!--                  <a class="dropdown-item" href="#" @click.prevent="$refs.upload.remove(file)">Remove</a>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </td>-->
        </tr>
        </tbody>
      </table>
    </div>
    <vue-upload-component
        :ref="reference"
        @input-filter="inputFilter"
        @input-file="inputFile"
        :multiple="true"
        :accept="accept"
    >
      <b-button v-if="showAddFilesBtn"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          size=""
          variant="info"
      > {{$t('uploader.addAFile')}}
      </b-button>
    </vue-upload-component>
  </div>

</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BModal
}
  from 'bootstrap-vue';
import Ripple from "vue-ripple-directive";

export default {
  data: ()=> ({
    name: 'file',
    editFileId: 'editFile',
    removeFileId: 'removeFile',
    editFileIndex: null,
    removeImageAcc: false,
    itemToDelete: null
    // ditFile: {
    //   show: false,
    //   name: '',
    // }
  }),

  props: {
    files: {
      default: function (){
        return []
      }
    },
    attachFileType: {
      default: null
    },
    addAFileMutation: {
      default: null
    },
    editAFileMutation: {
      default: null
    },
    removeAFileMutation: {
      default: null
    },
    addedFilesMutation: {
      default: null
    },
    attachedPayloadMutation: {
      default: null
    },
    description: {
      default: false
    },
    payloadProps: {
      default: []
    },
    type: {
      default: 'create'
    },
    reference: {
      default: null
    },
    accept: {
      default: 'image/png, image/gif, image/jpeg, image/webp'
    },
    showAddFilesBtn:{
      default : true,
      type : Boolean
    }
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal
  },
	directives: {
		Ripple,
	},
  mounted(){
    this.$imageViewer.images(this.files);
  },

  methods: {
    imageView(index) {
      this.$imageViewer.index(index);
      this.$imageViewer.show();
    },
    acceptToRemove(file){
      this.removeImageAcc = true;
      this.itemToDelete = file;
    },
    editImage(file){
      let tempFile = this.files[this.editFileIndex];
      file.blob = '';
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        file.blob = URL.createObjectURL(file.file);
      }
      file.url = '';
      if (file.blob) {
        file.url = file.blob;
      }
      tempFile.file = file.file;
      tempFile.url = file.url;
      this.$store.commit(this.editAFileMutation, {index: this.editFileIndex, file:tempFile})
      // // this.$refs[this.reference].active = true;
    },
    removeImage(){
      this.$store.commit(this.removeAFileMutation, {file: this.itemToDelete})
    },
    inputFilter: function (newFile, oldFile) {
      // newFiles.forEach(newFile => {
        if (!newFile.active) {
          // if (newFile.file){
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
              newFile.blob = URL.createObjectURL(newFile.file)
            }
            newFile.url = '';
            if (newFile.blob) {
              newFile.url = newFile.blob
            }
          // }
          // this.$store.commit(this.addAFileMutation, newFile);
          // let payload = new FormData;
          // this.payloadProps.forEach(item => {
          //   if (newFile[item]) {
          //     payload.append(item, newFile[item]);
          //   } else {
          //     payload.append(item, null);
          //   }
          // })
          // if (this.attachFileType) {
          //   payload.append('attachFileType', this.attachFileType);
          // }
          // commit('SET_CITIZEN_IDENTIFICATION_DOCUMENT', payload.formData)
          // this.$store.commit(this.addAFileMutation, newFile)
          // this.$store.commit(this.addedFilesMutation, newFile);
          this.$store.commit(this.addAFileMutation, newFile);

        }
      // })
      // if (newFile && !oldFile) {
      //   // Filter non-image file
      //   if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
      //     return prevent()
      //   }
      // }
      // Create a blob field\
      // newFile.forEach(newFile => {
      // this.$store.commit(this.addAFileMutation, newFile);
      // newFile.blob = ''
      //   let URL = window.URL || window.webkitURL
      //   if (URL && URL.createObjectURL) {
      //     newFile.blob = URL.createObjectURL(newFile.file)
      //   }
      //   // console.log('newFile', newFile)
      //   newFile.url = ''
      //   if (newFile.blob) {
      //     newFile.url = newFile.blob
      //   }
      //   // console.log(this.files)
      //   let payload = new FormData;
      //   this.payloadProps.forEach(item => {
      //     // console.log(item)
      //     if (newFile[item]) {
      //       payload.append(item, newFile[item]);
      //     } else {
      //       payload.append(item, null);
      //     }
      //   })
      //   if (this.attachFileType) {
      //     payload.append('attachFileType', this.attachFileType);
      //   }
      //   // commit('SET_CITIZEN_IDENTIFICATION_DOCUMENT', payload.formData)
      //   // this.$store.commit(this.addAFileMutation, newFile)
      //   this.$store.commit(this.attachedPayloadMutation, payload)

      // this.$refs.upload.add(newFile)
      // })
    },
    inputFile(){
    }
  }
}
</script>

<style>
.my-vue-upload-component .btn-group .dropdown-menu {
	display: block;
	visibility: hidden;
	transition: all .2s
}
.my-vue-upload-component .btn-group:hover > .dropdown-menu {
	visibility: visible;
}
.my-vue-upload-component label.dropdown-item {
	margin-bottom: 0;
}
.my-vue-upload-component .btn-group .dropdown-toggle {
	margin-right: .6rem
}
.td-image-thumb {
	max-width: 4em;
	max-height: 4em;
}
.my-vue-upload-component .filename {
	margin-bottom: .3rem
}
.my-vue-upload-component .btn-is-option {
	margin-top: 0.25rem;
}
.my-vue-upload-component .example-foorer {
	padding: .5rem 0;
	border-top: 1px solid #e9ecef;
	border-bottom: 1px solid #e9ecef;
}
.my-vue-upload-component .edit-image img {
	max-width: 100%;
}
.my-vue-upload-component .edit-image-tool {
	margin-top: .6rem;
}
.my-vue-upload-component .edit-image-tool .btn-group{
	margin-right: .6rem;
}
.my-vue-upload-component .footer-status {
	padding-top: .4rem;
}
.my-vue-upload-component .drop-active {
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	position: fixed;
	z-index: 9999;
	opacity: .6;
	text-align: center;
	background: #000;
}
.my-vue-upload-component .drop-active h3 {
	margin: -.5em 0 0;
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	-webkit-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
	font-size: 40px;
	color: #fff;
	padding: 0;
}
</style>